import { render, staticRenderFns } from "./ShoulderData.vue?vue&type=template&id=10f3cc23&scoped=true&"
import script from "./ShoulderData.vue?vue&type=script&lang=js&"
export * from "./ShoulderData.vue?vue&type=script&lang=js&"
import style0 from "./ShoulderData.vue?vue&type=style&index=0&id=10f3cc23&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f3cc23",
  null
  
)

export default component.exports